module.exports = __webpack_public_path__ + "static/media/J.dcbded82.png";